import useSWR from 'swr';
import { analyticsService, FailureCoverageResponse } from '../services/analyticsService';

interface UseFailureCoverageReturn {
  coverage: FailureCoverageResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useFailureCoverage = (): UseFailureCoverageReturn => {
  const { data, error, isLoading } = useSWR<FailureCoverageResponse, Error>(
    '/api/v1/analytics/service/failures/coverage',
    () => analyticsService.getFailureCoverage(),
    { revalidateOnFocus: false, revalidateOnReconnect: true, dedupingInterval: 5000 }
  );

  return { coverage: data, loading: isLoading, error };
};
